import { Tooltip } from "@material-ui/core";
import { activityTypeToName } from "../../../../utils/teacher_portal/activityTypeToString";
import { limitString } from "../../../../utils/string";
import React from "react";
import TeacherPortalLearningMaterialModal from "../learning_material/LearningMaterialModal";
import Icon from "../../../general/Icon";

const TeacherPortalLearningMaterialRow = ({ activityWithUsageData }) => {
    const [showModal, setShowModal] = React.useState(false)
    const activityNameShort = limitString(activityWithUsageData.activitytitle, 50)
    const activityIsShortened = activityNameShort !== activityWithUsageData.activitytitle
    return <>
        {showModal && <TeacherPortalLearningMaterialModal activityWithUsageData={activityWithUsageData} onClose={() => setShowModal(false)} />}
        <tr onClick={() => setShowModal(true)} className="cursor-pointer hover:bg-card_dark">
            <td className="px-4 py-3"><Tooltip title={activityTypeToName(activityWithUsageData.activitytype)}>
                <div className="flex items-center"><Icon type={activityWithUsageData.activitytype} color="black" />
                    <p className="ml-1 pt-1.5">{activityTypeToName(activityWithUsageData.activitytype)}</p>
                </div>
            </Tooltip></td>
            <th className="px-4 py-3 text-left font-normal" scope="row">
                {activityIsShortened ? <Tooltip title={activityWithUsageData.activitytitle}><div>{activityNameShort}</div></Tooltip> : activityWithUsageData.activitytitle}
            </th>
            <td className="px-4 py-3">{activityWithUsageData.first_accessed ? activityWithUsageData.first_accessed.toLocaleString().split('00:')[0] : "Never"}</td>
            <td className="px-4 py-3">{activityWithUsageData.last_accessed ? activityWithUsageData.last_accessed.toLocaleString().split('00:')[0] : "Never"}</td>
            <td className="px-4 py-3">{activityWithUsageData.total_usage_data.count_events}</td>
            <td className="px-4 py-3">{activityWithUsageData.total_usage_data.count_users}</td>
            <td className="px-4 py-3">{activityWithUsageData.total_usage_data.count_users_last_30_days}</td>
        </tr>
    </>
}
export default TeacherPortalLearningMaterialRow;
